module.exports = __webpack_public_path__ + "img/clientes-logo-3.4a738f83.png";